<div class="table">
    <p-table #tt [value]="customerLogs" [resizableColumns]="true" [autoLayout]="true" [paginator]="true"
    [rows]="numberOfRows" [pageLinks]="3" [rowsPerPageOptions]="isDialog? null : [10,20,30,50,100]">
        <ng-template pTemplate="header">
            <tr>
                <th>Data/hora</th>
                <th>Usuário</th>
                <th>Origem</th>
                <th>Cliente</th>
                <th>Ação</th>
                <th>Visualizar</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-customerLog>
            <tr>
                <td>{{customerLog.logTime | date: 'dd/MM/yyyy - HH:mm'}}</td>
                <td [pTooltip]="customerLog.user ? customerLog.user.fullName : ''" tooltipPosition="top">{{customerLog.user ? customerLog.user.username : ''}}</td>
                <td>{{customerLog.origin}}</td>
                <td>{{customerLog.name}}</td>
                <td>{{customerLog.operationLog | translate}}</td>
                <td>
                    <div class="table-action" (click)="openCustomerLogDialog(customerLog)" pTooltip="Visualizar" *ngIf="customerLog.oldDatas"
                        tooltipPosition="bottom">
                        <i class="pi pi-eye"></i>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">
                    Nenhum log encontrado
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>
